const ADMIN_BACKEND_URL = process.env.VUE_APP_ADMIN_BACKEND_URL
const PUBLIC_BACKEND_URL = process.env.VUE_APP_PUBLIC_BACKEND_URL

export default {
  // ADMIN ENDPOINT
  AUTH: `${ADMIN_BACKEND_URL}/auth`,
  CONSTANT: `${ADMIN_BACKEND_URL}/constant`,

  ACTIONS: `${ADMIN_BACKEND_URL}/actions`,
  MANAGED_RESOURCES: `${ADMIN_BACKEND_URL}/managed_resources`,

  TAG: `${ADMIN_BACKEND_URL}/tag`,
  USER: `${ADMIN_BACKEND_URL}/user`,
  GROUP: `${ADMIN_BACKEND_URL}/group`,
  PLACE: `${ADMIN_BACKEND_URL}/place`,
  LIKES: `${ADMIN_BACKEND_URL}/likes`,
  PACKAGE: `${ADMIN_BACKEND_URL}/package`,
  STORAGE: `${ADMIN_BACKEND_URL}/storage`,
  COMMENT: `${ADMIN_BACKEND_URL}/comment`,
  BANNERS: `${ADMIN_BACKEND_URL}/banners`,
  ARTIFACT: `${ADMIN_BACKEND_URL}/artifact`,
  TOUR_DAY: `${ADMIN_BACKEND_URL}/tour-day`,
  TOUR_DES: `${ADMIN_BACKEND_URL}/tour-des`,
  ROOM_TYPE: `${ADMIN_BACKEND_URL}/room-type`,
  ACTIVITY_LOGS: `${ADMIN_BACKEND_URL}/activity-logs`,
  RECEIPT: `${ADMIN_BACKEND_URL}/receipt`,
  DISH: `${ADMIN_BACKEND_URL}/dish`,
  DISH_GROUP: `${ADMIN_BACKEND_URL}/dish_group`,
  DISH_SUBCRIPTION: `${ADMIN_BACKEND_URL}/dish_subscription`,
  PLACE_RELATED: `${ADMIN_BACKEND_URL}/place_related`,
  DEPARTMENT: `${ADMIN_BACKEND_URL}/department`,
  WORKING_LOCATION: `${ADMIN_BACKEND_URL}/working_location`,
  USER_REGISTER_FORMS: `${ADMIN_BACKEND_URL}/user_register_forms`,
  STORAGE_URL: `${ADMIN_BACKEND_URL}/storage/url`,
  ANALYTICS: `${ADMIN_BACKEND_URL}/analytics`,

  LIST_USERS: `${ADMIN_BACKEND_URL}/user/list`,
  LIST_PLACES: `${ADMIN_BACKEND_URL}/place/list`,
  LIST_STORAGES: `${ADMIN_BACKEND_URL}/storage/list`,
  LIST_COMMENTS: `${ADMIN_BACKEND_URL}/comment/list`,
  LIST_ARTIFACTS: `${ADMIN_BACKEND_URL}/artifact/list`,
  LIST_TOUR_DAYS: `${ADMIN_BACKEND_URL}/tour-day/list`,
  LIST_TOUR_DES: `${ADMIN_BACKEND_URL}/tour-des/list`,
  LIST_ROOM_TYPES: `${ADMIN_BACKEND_URL}/room-type/list`,
  LIST_PLACE_GROUPS: `${ADMIN_BACKEND_URL}/place/group/list`,
  PLACE_GROUP: `${ADMIN_BACKEND_URL}/place/group`,
  PLACE_GROUP_ITEM: `${ADMIN_BACKEND_URL}/place/group/item`,
  CHANGE_ORDER: `${ADMIN_BACKEND_URL}/storage/change-order`,
  RECEIPT_STATISTIC: `${ADMIN_BACKEND_URL}/receipt/statistic`,
  CLASSIFICATION: `${ADMIN_BACKEND_URL}/artifact/classification`,
  PLACE_ENABLE: `${ADMIN_BACKEND_URL}/place/enable`,

  ORGANIZATIONS: `${ADMIN_BACKEND_URL}/organizations`,
  ORGANIZATIONS_ADD_MEMBER: `${ADMIN_BACKEND_URL}/organizations/add-member`,
  ORGANIZATIONS_REMOVE_MEMBER: `${ADMIN_BACKEND_URL}/organizations/remove-member`,
  ORGANIZATIONS_ADD_OWNER: `${ADMIN_BACKEND_URL}/organizations/add-owner`,
  ORGANIZATIONS_ADD_ADMIN: `${ADMIN_BACKEND_URL}/organizations/add-admin`,
  ORGANIZATIONS_APPOINT_OWNER: `${ADMIN_BACKEND_URL}/organizations/appoint-owner`,

  PLACE_CATEGORIES: `${ADMIN_BACKEND_URL}/place_categories`,
  GOONG_AUTOCOMPLETE: `${ADMIN_BACKEND_URL}/goong/autocomplete`,
  GOONG_DETAIL: `${ADMIN_BACKEND_URL}/goong/detail`,

  DISPLAY_MODELS: `${ADMIN_BACKEND_URL}/display_models`,

  HIERARCHY: `${ADMIN_BACKEND_URL}/hierarchy`,
  HIERARCHY_ITEM: `${ADMIN_BACKEND_URL}/hierarchy_item`,

  ORGANIZATION_ACTIONS: `${ADMIN_BACKEND_URL}/organization_actions`,
  ORGANIZATION_ACTION_ASSIGNEES: `${ADMIN_BACKEND_URL}/organization_action_assignees`,

  BOARDS: `${ADMIN_BACKEND_URL}/boards`,
  BOARD_ITEMS: `${ADMIN_BACKEND_URL}/board-items`,
  RECORD_UTILS_COUNT: `${ADMIN_BACKEND_URL}/record-utils/count`,

  PRODUCTS: `${ADMIN_BACKEND_URL}/products`,
  PRICES: `${ADMIN_BACKEND_URL}/prices`,

  PLACE_FACILITY_GROUPS: `${ADMIN_BACKEND_URL}/place_facility_groups`,
  PLACE_FACILITIES: `${ADMIN_BACKEND_URL}/place_facilities`,
  PLACE_SERVICES: `${ADMIN_BACKEND_URL}/place_services`,
  PLACE_RATINGS: `${ADMIN_BACKEND_URL}/place_ratings`,

  IAM_ACTIONS: `${ADMIN_BACKEND_URL}/iam/actions`,

  // PUBLIC ENDPOINT
  PLACE_PUBLIC: `${PUBLIC_BACKEND_URL}/place`,
  ARTIFACT_PUBLIC: `${PUBLIC_BACKEND_URL}/artifact`,
  LIST_STORAGE_PUBLIC: `${PUBLIC_BACKEND_URL}/storage/list`,
  LIST_PLACE_ARTIFACT_PUBLIC: `${PUBLIC_BACKEND_URL}/place/artifact`,
  ARTIFACT_CLASSIFICATION_PUBLIC: `${PUBLIC_BACKEND_URL}/artifact/classification/simplify`
}
